module.exports = __webpack_public_path__ + "static/media/digital-patient-management-healthcare-platform.a4648113.webp";